import React, { Fragment, useRef, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { ListItemIcon, ListItemText, Tooltip, Button, Menu, MenuItem } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment';

const GenericMoreButton = props => {
  const classes = useStyles();
  const moreRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const transfer = useSelector(({ transfer }) => transfer.data);
  const startDate = useSelector(({ transfer }) => transfer.startDate);
  const endDate = useSelector(({ transfer }) => transfer.endDate);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const exportCSV = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Transfer Sheet');

    sheet.columns = [
      { header: 'Receipt Name', key: 'receiptName', width: 25 },
      { header: 'Account', key: 'account', width: 15 },
      { header: 'Receipt ID', key: 'receiptId', width: 20 },
      { header: 'Amount', key: 'amount', width: 15 },
      { header: 'Paid', key: 'paid', width: 30 },
      { header: 'Status', key: 'status', width: 15 }
    ];

    transfer.data.map(d => {
      return sheet.addRow({
        receiptName: d.receiptName,
        account: d.account,
        receiptId: d.receiptId,
        amount: d.amount,
        paid: d.paid,
        status: d.status
      });
    });

    workbook.csv.writeBuffer().then(buf => {
      saveAs(
        new Blob([buf]),
        `Transfer-${moment(startDate).format('YYYYMMDD')}-${moment(endDate).format(
          'YYYYMMDD'
        )}.csv`
      );
    });
  };

  const exportExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Transfer Sheet');

    sheet.columns = [
      { header: 'Receipt Name', key: 'receiptName', width: 25 },
      { header: 'Account', key: 'account', width: 15 },
      { header: 'Receipt ID', key: 'receiptId', width: 20 },
      { header: 'Amount', key: 'amount', width: 15 },
      { header: 'Paid', key: 'paid', width: 30 },
      { header: 'Status', key: 'status', width: 15 }
    ];

    transfer.data.map(d => {
      return sheet.addRow({
        receiptName: d.receiptName,
        account: d.account,
        receiptId: d.receiptId,
        amount: d.amount,
        paid: d.paid,
        status: d.status
      });
    });

    workbook.xlsx.writeBuffer().then(buf => {
      saveAs(
        new Blob([buf]),
        `Transfer-${moment(startDate).format('YYYYMMDD')}-${moment(endDate).format(
          'YYYYMMDD'
        )}.xlsx`
      );
    });
  };

  return (
    <Fragment>
      <Tooltip title="More options">
        <Button
          {...props}
          color="primary"
          onClick={handleMenuOpen}
          ref={moreRef}
          size="small"
          variant="outlined"
        >
                    Export
        </Button>
      </Tooltip>
      <Menu
        anchorEl={moreRef.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        classes={{ paper: classes.menu }}
        onClose={handleMenuClose}
        open={openMenu}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <MenuItem onClick={() => exportCSV()}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faFileExcel} />
          </ListItemIcon>
          <ListItemText primary="Export as CSV" />
        </MenuItem>
        <MenuItem onClick={() => exportExcel()}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faFileExcel} />
          </ListItemIcon>
          <ListItemText primary="Export as Excel" />
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

GenericMoreButton.propTypes = {
  className: PropTypes.string
};

export default memo(GenericMoreButton);

const useStyles = makeStyles(() => ({}));
